import { defineComponent as r, computed as l, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "38023d11-b5ed-44ff-9f7f-4b069842c861" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#38023d11-b5ed-44ff-9f7f-4b069842c861)" }, p = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "m0 0 216.9 301.6L512 512V0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m0 0 512 512H0z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#ff9811",
  d: "M320.4 320.4A38.9 38.9 0 0 1 272 265l-3.2-1.7a72.5 72.5 0 0 0 30.5-125l-23.3 24a38.9 38.9 0 0 1-23.8 69.5v3.6a72.5 72.5 0 0 0-123.2 36l32.4 8.2a38.9 38.9 0 0 1 72-14l3.2-2a72.5 72.5 0 0 0 92.7 89l-9-32.3zM252.7 254z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M348.2 170.8 330 235.4l-54.3-10-35-72.1-94.4 33.5-7.4-21-24.7-3 18.6 52.4 65-16.6 18.4 52-45 66.3 76.4 65-14.5 17 9.7 22.9 36-42.4-46.7-48 35.8-42 79.8 5.8 18.2-98.5 22 4 15-19.8zM253.4 255z"
}, null, -1), z = { fill: "none" }, w = ["r"], N = /* @__PURE__ */ r({
  __name: "it-82",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const t = a, o = l(() => 512 + 2 * t.strokeWidth), s = l(() => -t.strokeWidth), n = l(() => 256 + t.strokeWidth / 2);
    return (y, W) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (i(), c("title", p, d(t.flagName), 1)) : f("", !0),
        k,
        g,
        v,
        x
      ]),
      e("g", z, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, h));
  }
});
export {
  N as default
};
//# sourceMappingURL=it-82-cf0d3d20.js.map
